export default {
  outList: [
    {
      light_point_1: [
        {
          title: '悦享颜值',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '锋齿钻列格栅'
        },
      ],
      light_point_2: [
        {
          title: '大灯造型',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: '灵眸LED日行灯'
        },
      ],
      light_point_3: [
        {
          title: '安全守护，磐石车身',
          type: 'image',
          video: '',
          image: 'lightPoint/4/2.jpg',
          text: '170mm超宽，前吸能盒，2.8mm超厚，防撞钢梁，航空级铝合金，84%超宽覆盖率'
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1: [

        {
          title: '15.6吋超大2.5K高清屏',
          type: 'image',
          video: '',
          image: 'lightPoint/2/1.jpg',
          text: '高端科技智慧大屏，享受一场视听盛宴'
        },
      ],
      light_point_3: [

        {
          title: '零重力女王副驾',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '女王座椅，躺下就不想离开'
        },
      ],
    }
  ],
  tab1: [
    {
      title: '锋齿钻列格栅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: ''
    },
    {
      title: '全新车色浅云灰',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: ''
    },
    {
      title: '追猎贯穿尾灯',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: ''
    },
    {
      title: '云憩环抱式座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: ''
    },
    {
      title: '整车软包区域面积78.9%',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: '提供更加舒适的触感，赋予生活更高的品质。'
    }
  ],
  tab2: [
    {
      title: '15.6吋超大2.5K高清屏',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '高端科技智慧大屏，享受一场视听盛宴'
    },
    {
      title: 'SONY  12扬环绕音响',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '金耳朵团队专属调音，感受全方位的音效环绕'
    },
    {
      title: '零重力女王副驾',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '女王座椅，躺下就不想离开'
    },
    {
      title: 'C-PURE奇瑞 净立方绿色座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '打造专属“私人氧吧”，全方位守护您和家人的呼吸健康'
    },
    {
      title: '1930L后备箱空间',
      type: 'image',
      video: '',
      image: 'lightPoint/2/5.jpg',
      text: ''
    },
    {
      title: 'AI大模型智慧交互',
      type: 'image',
      video: '',
      image: 'lightPoint/2/6.jpg',
      text: '全时免唤醒，方言免切换，流式语音识别'
    },
  ],
  tab3: [
    {
      title: '鲲鹏动力1.6TGDI+7DCT',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '1.6TGDI+7DCT黄金动力组合，发动机最大功率145kW，峰值扭矩290N·m'
    },
  ],
  tab4: [
    {
      title: '配备10气囊防护',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: '拓展安全边界，将防护延伸至每一个角落'
    },
    {
      title: '安全守护，磐石车身',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '170mm超宽，前吸能盒，2.8mm超厚，防撞钢梁，航空级铝合金，84%超宽覆盖率'
    }
  ],
}
